import { useEffect, useState } from 'react';
import { useGetProductGroup } from 'api/productGroup';
import {
  GetProductGroupParams,
  ProductGroup,
} from 'api/productGroup/productGroup.types';
import { AutocompletePaginationAsync } from 'components/Inputs';
import { FieldValues } from 'react-hook-form';
import { createHandleOnBlur, handleChange } from 'utils/form.utils';

export default function CommodityAutocomplete<
  TFieldValues extends FieldValues = FieldValues,
>({ formProps, error }: { formProps: TFieldValues; error: boolean }) {
  const { data, loading, getProductGroup } = useGetProductGroup();
  const [options, setOptions] = useState<ProductGroup[]>([]);
  const [productGroupParams, setProductGroupParams] =
    useState<GetProductGroupParams>({
      filterText: '',
      pageNumber: 1,
    });
  useEffect(() => {
    getProductGroup(productGroupParams);
  }, [getProductGroup, productGroupParams]);

  useEffect(() => {
    if (data?.length) {
      const fetchedOptions = data.map((productGroup) => ({
        id: productGroup.id,
        code: productGroup.code,
        enabled: productGroup.enabled,
      }));
      const filteredOptions = fetchedOptions.filter(
        (activity) => activity.enabled,
      );
      setOptions((prev) => [...prev, ...filteredOptions]);
    }
  }, [data]);
  return (
    <AutocompletePaginationAsync
      {...formProps}
      padding='dense'
      width={280}
      value={formProps.field.value}
      multiple
      error={error}
      loading={loading}
      options={options}
      isOptionEqualToValue={(option, value) => value?.id === option?.id}
      getOptionLabel={(o) => o.code}
      handleSearchChange={handleChange(setOptions, setProductGroupParams)}
      onChange={(_, data) => formProps.field.onChange(data)}
      onScrollBottom={() =>
        setProductGroupParams((prev: any) => ({
          ...prev,
          pageNumber: prev.pageNumber + 1,
        }))
      }
      onBlur={createHandleOnBlur(
        setOptions,
        setProductGroupParams,
        formProps.field.onBlur,
      )}
    />
  );
}
